var Component = require("!../../../../node_modules/.12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.12.2.2@vue-loader/lib/selector?type=script&index=0!./Query.vue"),
  /* template */
  require("!!../../../../node_modules/.12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-489b6494\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../node_modules/.12.2.2@vue-loader/lib/selector?type=template&index=0!./Query.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/requirement/components/Query.vue
// module id = 12
// module chunks = 0